import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import {
  faCaretDown,
  faCog,
  faPowerOff,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { NavDropdown, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { logout } from "../../actions/authAction";
import { changeRole } from "../../actions/roleAction";
import Avatar from "../../assets/images/default-avatar.jpg";
import Select from "react-select";
import {
  changeToken,
  getAdminDetail,
  getPractitionerForAdmin,
  getUserDetail,
  setPractitionerForAdmin,
  setUserRole,
} from "../../utils/helper";
import history from "../../utils/history";
import DropDownItem from "../DropDownItem";
import { adminAction } from "../../actions/practitionerAction";
import { getPatientNotification } from "../../actions/dashboardAction";
import { BUCKET_NAME } from "../../constants/states";
import Loader from "../Loader";
const Header = ({ showUserSection }) => {
  const [user, setUser] = useState({});
  const [showUserDetail, SetShowUserDetail] = useState(false);
  const practitionerListForAdmin = useSelector(
    (state) => state.practitioner.practitionerListForAdmin
  );
  const [practitioner, setPractitioner] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const setUserDetail = () => {
    if (showUserSection) {
      const userDetail = getUserDetail();
      if (userDetail) {
        setUser({
          firstName: userDetail.firstName,
          lastName: userDetail.lastName,
          mainRole: userDetail.mainRole,
          roleNames: userDetail.roleNames,
        });
        SetShowUserDetail(true);
        dispatch(changeRole(userDetail.mainRole));
      }
    }
  };

  const setPractitionerDetail = (detail = null) => {
    if (detail) {
      setPractitioner({
        first_name: detail.first_name,
        last_name: detail.last_name,
        user_id: detail.user_id,
        user_email: detail.user_email,
        customerId: detail.customerId,
      });

      const params = {
        token: getUserDetail()?.token,
        practitionerId: detail.user_id,
        action: "switchPractitionerForAdmin",
      };

      dispatch(
        adminAction({ params: params }, (data) => {
          detail.token = data.token;
          detail.tokenExpiryDate = data.tokenExpiryDate;
          setPractitionerForAdmin(detail);
          changeToken(
            data.token,
            data.tokenExpiryDate,
            detail.customerId,
            detail.user_id,
            detail.first_name,
            detail.last_name
          );
          dispatch(getPatientNotification(1));
          history.push("/app");
          setTimeout(() => {
            setIsLoading(false);
          }, 2000);
        })
      );
    }
  };

  useEffect(() => {
    if (!practitioner && practitionerListForAdmin?.length > 0) {
      let detail = getPractitionerForAdmin();
      if (detail) {
        setPractitioner({
          first_name: detail.first_name,
          last_name: detail.last_name,
          user_id: detail.user_id,
          user_email: detail.user_email,
        });
      }
    }
  }, [practitionerListForAdmin]);

  const setRole = (value) => {
    setPractitionerForAdmin(null);
    setUserRole(value);
    setUserDetail();
    setPractitioner(null);
    history.push("/app");
  };

  useEffect(setUserDetail, [showUserSection, dispatch]);

  const [localStorageValue, setLocalStorageValue] = useState(
    getAdminDetail() ? getAdminDetail() : getUserDetail()
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setLocalStorageValue(
        getAdminDetail() ? getAdminDetail() : getUserDetail()
      );
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const optionRenderer = ({ label }, { inputValue }) => {
    const matches = match(label, inputValue);
    const parts = parse(label, matches);
    return (
      <div>
        {parts.map((part, index) => (
          <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
            {part.text}
          </span>
        ))}
      </div>
    );
  };

  const checkId = () => {
    let adminDetail = getAdminDetail();
    if (adminDetail) {
      return adminDetail.id;
    } else {
      return getUserDetail()?.id;
    }
  };

  return (
    <header className="header">
      {isLoading && <Loader />}
      <div className="container-fluid">
        <Row className="justify-content-between">
          <div className="navbar-brand">
            <Link to="/app">
              <img
                id="logo"
                src={
                  `https://storage.googleapis.com/${BUCKET_NAME}/logo/mhp.png` +
                  `?${Math.random()}`
                }
                className="d-inline-block align-top"
                alt="logo"
              />
            </Link>
          </div>
          {showUserDetail && (
            <div className="user-nav">
              <span>Acting as</span>
              {user?.roleNames?.length > 0 ? (
                <NavDropdown
                  rootCloseEvent="click"
                  title={
                    <>
                      <FontAwesomeIcon icon={faCaretDown} />{" "}
                      {user.mainRole.roleName}{" "}
                      {user.mainRole.val == 6 ? "" : ":"}
                    </>
                  }
                  id="role-nav-dropdown"
                >
                  {user.roleNames.map((x) => (
                    <NavDropdown.Item key={x.val}>
                      <DropDownItem
                        icon={faUser}
                        text={x.roleName}
                        onClick={() => setRole(x.val)}
                      />
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
              ) : (
                <p className="role">
                  {" "}
                  {user.mainRole.roleName} {user.mainRole.val == 6 ? "" : ":"}
                </p>
              )}
              {user?.mainRole?.val == 6 ? (
                <>
                  {practitionerListForAdmin?.length > 0 ? (
                    <>
                      <span> for Practitioner: </span>

                      <Select
                        className="header-select"
                        onChange={(e) => {
                          setIsLoading(true);
                          setPractitionerDetail(e.value);
                        }}
                        placeholder="Select A Practitioner"
                        value={
                          practitioner
                            ? {
                                label: `${practitioner.first_name} ${practitioner.last_name}`,
                              }
                            : ""
                        }
                        options={practitionerListForAdmin
                          .filter((x) => x.user_id != checkId())
                          .map((x) => ({
                            value: x,
                            label: `${x.first_name} ${x.last_name} (${x.user_email})`,
                          }))}
                        styles={{
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                            minWidth: "280px",
                            width: "280px",
                          }),
                          control: (props, { isDisabled }) => ({
                            ...props,
                            cursor: isDisabled ? "not-allowed" : "pointer",
                            pointerEvents: "auto",
                            minWidth: "280px",
                            width: "280px",
                            marginLeft: "10px",
                          }),
                        }}
                        menuPortalTarget={document.body}
                        menuPlacement={"bottom"}
                        menuShouldScrollIntoView={false}
                        formatOptionLabel={optionRenderer}
                      ></Select>
                    </>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}
              <NavDropdown
                rootCloseEvent="click"
                className="user-drop-nav"
                title={
                  <div className="d-flex">
                    <span className="user-name">
                      {localStorageValue?.firstName}{" "}
                      {localStorageValue?.lastName}
                    </span>
                    <div className="avatar">
                      <img
                        src={
                          localStorageValue?.hasProfilePicture
                            ? `https://storage.googleapis.com/${BUCKET_NAME}/user/${
                                localStorageValue?.id
                              }.png?${Math.random()}`
                            : Avatar
                        }
                        alt="user"
                      />
                    </div>
                    <div className="user-drop-icon">
                      <FontAwesomeIcon icon={faCaretDown} />
                    </div>
                  </div>
                }
                id="user-nav-dropdown"
              >
                <NavDropdown.Item>
                  <DropDownItem
                    icon={faCog}
                    text="Profile"
                    onClick={() => {
                      history.push("/app/profile");
                    }}
                  />
                </NavDropdown.Item>
                <NavDropdown.Item>
                  <DropDownItem
                    icon={faPowerOff}
                    text="Logout"
                    onClick={() => dispatch(logout())}
                  />
                </NavDropdown.Item>
              </NavDropdown>
            </div>
          )}
        </Row>
      </div>
    </header>
  );
};

export default Header;
